module.exports = __webpack_public_path__ + "img/anthony.fcf7b0a7.jpg";